import React, { useEffect, useState } from "react";
import Background from "../../assets/bg.svg";
import Hands from "../../assets/hands.svg";
import { ReactComponent as P } from "../../assets/p1.svg";
import { ReactComponent as Pb } from "../../assets/p2.svg";
import { ReactComponent as User } from "../../assets/user1.svg";
import { ReactComponent as Userb } from "../../assets/user2.svg";

import { Link, useNavigate } from "react-router-dom";
import LoginLayout from "../../components/LoginLayout";
import { handleAuthRedirect } from "../../constants/utils";
import Logo from "../../assets/logo.svg";

const Landing = () => {
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [useHovered, setUseHovered] = useState(false);
  useEffect(() => {
    const AdminLogin = localStorage.getItem("Login");
    const Token = localStorage.getItem("accessToken");
    if (AdminLogin && Token) {
      handleAuthRedirect(AdminLogin, navigate);
    }
  }, [navigate]);

  return (
    <div>
      <LoginLayout image={Hands} bg={Background}>
        <div className="relative">
          <div className="absolute w-5 h-5 bg-blue-500 rounded-full left-10 top-7" />
          <div className="absolute top-0 right-0 w-24 h-24 bg-blue-500 rounded-bl-full" />
        </div>

        <div className="min-h-screen flex items-center justify-center">
          <div className="mx-4 sm:mx-6 lg:mx-20 xl:mx-40 w-full max-w-md">
            <div className="flex justify-center">
              <Link to="https://insurancehive.com/">
                <img src={Logo} alt="logo" className="cursor-pointer" />
              </Link>
            </div>
            <div className="space-y-5 flex flex-col items-center">
              <p className="text-2xl sm:text-3xl lg:text-4xl font-bold">
                Welcome Back
              </p>
              <p className="font-bold mt-2">Please Select to Continue</p>
            </div>
            <div className="flex justify-center md:justify-start mt-5">
              <div className="grid md:grid-cols-2 gap-y-2 md:gap-x-10">
                <div className="hover:text-blue-500">
                  <Link to="/agent/login" className="no-underline">
                    <div
                      className="bg-[#F2F2F2] hover:bg-[white] rounded-lg hover:border-blue-500 hover:ring-4 hover:ring-[#4A83FD] hover:ring hover:ring border border-transparent"
                      onMouseEnter={() => setHovered(true)}
                      onMouseLeave={() => setHovered(false)}
                    >
                      <div className="w-full">
                        <div className="flex ">{hovered ? <Pb /> : <P />}</div>
                      </div>
                    </div>
                  </Link>
                  <div className="flex justify-center text-center pt-4">
                    <p>Insurance Agent</p>
                  </div>
                </div>
                <div className="hover:text-blue-500 ">
                  <Link to="/user/login" className="no-underline">
                    <div
                      className="bg-[#F2F2F2] hover:bg-[white] rounded-lg hover:bg-white  border border-transparent hover:ring-4 hover:ring-[#4A83FD]"
                      onMouseEnter={() => setUseHovered(true)}
                      onMouseLeave={() => setUseHovered(false)}
                    >
                      <div className="w-full">
                        <div className="flex justify-center">
                          {useHovered ? <Userb /> : <User />}
                        </div>
                      </div>
                    </div>
                  </Link>
                  <div className="flex justify-center text-center pt-4 ">
                    <p>Policy Holder</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute bottom-7 w-5 h-5 bg-blue-500 rounded-full left-10" />
          <div className="absolute right-0 bottom-0 w-24 h-24 bg-blue-500 rounded-tl-full" />
        </div>
      </LoginLayout>
    </div>
  );
};

export default Landing;
